import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import { UIActions } from '../ui/uiSlice';

const DELETE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation deletePost($id: ID!) {
    deletePost(id: $id) {
      id
    }
  }
`);

const deletedPostIds = new Set<string>();

export const isDeletedLocally = (postId: string) => {
  return deletedPostIds.has(postId);
};

const useDeletePost = () => {
  const dispatch = useAppDispatch();
  const [deletePost] = useMutation(DELETE_POST_MUTATION, {
    update(cache, { data }) {
      if (data?.deletePost) {
        cache.evict({ id: cache.identify(data.deletePost) });
      }
    },
  });

  return useCallback(
    async (id: string) => {
      deletedPostIds.add(id);
      dispatch(UIActions.removeFromRecentlyViewedPostIds(id));
      await deletePost({ variables: { id } });
    },
    [dispatch, deletePost],
  );
};

export default useDeletePost;
